export const GO_LOW_HEIGHT_LIMIT_ADAPTION_STEPPER = '700px'
export const GO_LOW_HEIGHT_LIMIT_ADAPTION_OPERATION = '780px'
export const GO_LOW_HEIGHT_LIMIT_ADAPTION_OPERATION_NUMBER = '780'
export const GO_LOW_HEIGHT_LIMIT_ADAPTION_APPLICATION = '950px'
export const GO_LOW_HEIGHT_LIMIT_ADAPTION_OPTIONALS = '870px'
export const GO_OPERATIONS_MAX_WIDTH = '1280px'
export const GvShareEmailWidthColumnBreakpoint = 1600
export const OPERATION_FAMILY_ID = '02759'
export const FAMILY_ID_APPLICATION = '02758'
